export type WorkspaceMode = 'investor' | 'operator';

export const WORKSPACE_MODE_STORAGE_KEY = 'zoe.workspace.mode';
export const COMPANY_URL_STORAGE_KEY = 'zoe.workspace.company_url';
export const WORKSPACE_NAME_STORAGE_KEY = 'zoe.workspace.name';
export const WORKSPACE_ID_STORAGE_KEY = 'zoe.workspace.id';
export const USER_EMAIL_STORAGE_KEY = 'zoe.user.email';

export function isWorkspaceMode(value: unknown): value is WorkspaceMode {
  return value === 'investor' || value === 'operator';
}

export function getStoredWorkspaceMode(): WorkspaceMode {
  if (typeof window === 'undefined') return 'investor';
  const stored = window.localStorage.getItem(WORKSPACE_MODE_STORAGE_KEY);
  return isWorkspaceMode(stored) ? stored : 'investor';
}

export function storeWorkspaceMode(mode: WorkspaceMode): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(WORKSPACE_MODE_STORAGE_KEY, mode);
}

export function storeCompanyUrl(url: string): void {
  if (typeof window === 'undefined') return;
  const cleaned = url.trim();
  if (cleaned) {
    window.localStorage.setItem(COMPANY_URL_STORAGE_KEY, cleaned);
  } else {
    window.localStorage.removeItem(COMPANY_URL_STORAGE_KEY);
  }
}

export function storeWorkspaceName(name: string): void {
  if (typeof window === 'undefined') return;
  const cleaned = name.trim();
  if (cleaned) {
    window.localStorage.setItem(WORKSPACE_NAME_STORAGE_KEY, cleaned);
  } else {
    window.localStorage.removeItem(WORKSPACE_NAME_STORAGE_KEY);
  }
}

export function getStoredWorkspaceName(): string {
  if (typeof window === 'undefined') return '';
  return window.localStorage.getItem(WORKSPACE_NAME_STORAGE_KEY)?.trim() ?? '';
}

export function syncWorkspaceIdentity(
  workspaceId: string | null | undefined,
  name: string | null | undefined,
): void {
  if (typeof window === 'undefined') return;
  const id = workspaceId?.trim();
  if (!id) {
    window.localStorage.removeItem(WORKSPACE_ID_STORAGE_KEY);
    window.localStorage.removeItem(WORKSPACE_NAME_STORAGE_KEY);
    return;
  }
  window.localStorage.setItem(WORKSPACE_ID_STORAGE_KEY, id);
  storeWorkspaceName(name ?? '');
}

export function storeUserEmail(email: string | null | undefined): void {
  if (typeof window === 'undefined') return;
  const cleaned = email?.trim();
  if (cleaned) {
    window.localStorage.setItem(USER_EMAIL_STORAGE_KEY, cleaned);
  } else {
    window.localStorage.removeItem(USER_EMAIL_STORAGE_KEY);
  }
}

export function getStoredUserEmail(): string {
  if (typeof window === 'undefined') return '';
  return window.localStorage.getItem(USER_EMAIL_STORAGE_KEY)?.trim() ?? '';
}
